import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [isPaymentInProgress, setIsPaymentInProgress] = useState(false);

  const startPayment = () => setIsPaymentInProgress(true);
  const endPayment = () => setIsPaymentInProgress(false);

  return (
    <PaymentContext.Provider value={{ isPaymentInProgress, startPayment, endPayment }}>
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('usePayment must be used within a PaymentProvider');
  }
  return context;
};

export default PaymentContext;
